import * as React from "react";
import * as S from "./pagination.styles";
import "./pagination.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const UsePagination = ({ step, setStep, formik, verifySeccess }) => {
  return (
    <S.Pagination>
      <S.PaginationUl>
        <S.PaginationItem>
          {step === 1 ? (
            <div style={{ width: "90px" }}></div>
          ) : (
            <S.BtnPrev onClick={() => setStep(step - 1)}>
              <S.Svg>
                <ArrowForwardIcon />
              </S.Svg>
              قبلی
            </S.BtnPrev>
          )}
        </S.PaginationItem>
        <div style={{ display: "flex", alignItems: "center" }}>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 1 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 2 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 3 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 4 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 5 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 6 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
          <S.PaginationItem>
            <S.Step
              style={{
                background: step === 7 ? "#5FD3D3" : "#EAEDF1",
              }}
            ></S.Step>
          </S.PaginationItem>
        </div>
        <S.PaginationItem>
          <S.BtnNext
            id={` step-${step}`}
            className="btnnex"
            type="submit"
            // disabled={!formik.isValid && !verifySeccess ? true : false}
          >
            بعدی
            <S.Svg>
              <ArrowBackIcon />
            </S.Svg>
          </S.BtnNext>
        </S.PaginationItem>
      </S.PaginationUl>
    </S.Pagination>
  );
};

export default UsePagination;
